import { styled } from '@volkswagen-onehub/components-core';

export const TabTitle = styled.div`
  font-weight: 400;
`;
